import { createSlice } from "@reduxjs/toolkit";

//STATE
const initialState = {
  rows: [],
  isLoading: false,
};

//STORE SLICE
export const itemCategoriesListSlice = createSlice({
  name: "itemCategoriesListSlice",
  initialState,
  //REDUCER
  reducers: {
    setItemCategoriesList(state, action) {
      return {
        ...state,
        rows:  action.payload,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    addCategories(state, action) {
      return {
        ...state,
        rows: [...state.rows, action.payload],
      };
    },
    editCategories(state, action) {
      return {
        ...state,
        rows: state.rows.map((row) =>
          row.id === action.payload.id ? action.payload : row
        ),
      };
    },
    deleteCategories(state, action) {
      return {
        ...state,
        rows: state.rows.filter((row) => row.id !== action.payload),
      };
    },
  },
});

//ACTIONS
export const {
    setItemCategoriesList,
    showLoading,
    hideLoading,
    addCategories,
    editCategories,
    deleteCategories,
} = itemCategoriesListSlice.actions;

export default itemCategoriesListSlice.reducer;
